import * as _ from 'lodash';
import { DrawFence } from "../fence/DrawFence";
import { DrawRoofForPanel } from "../panel/drawRoofForPanel";
import { ModGroup } from "../panel/ModGroup";
import { ModList } from "../panel/ModList";
import { Global } from "../utilities/global";

export function getHgroups(): any {
    let group: any = DrawRoofForPanel.layerPanel.find(".panelGroupSelected");

    var groupIds: string[] = [];
    if (group && group.length > 0) {
        // group postion cals
        var xDiff = group[0].getX();
        var yDiff = group[0].getY();
        const children: any = [...group[0].getChildren()];
        Global.panelClientRectDetailsForElipseError = children[0].getClientRect();
        const g = children.map((item: any) => {
            const attrs = { ...item.getAttrs() };
            attrs.x += xDiff;
            attrs.y += yDiff;
            groupIds.push(attrs.id);
            return attrs;
        });
        // console.log(g);
        group = g;
    }
    let listOfGroups: any = [];
    let obj: any = DrawRoofForPanel.layerPanel.find("." + Global.panelsOnRoof);
    let listPanels: any[] = [];
    ModList.listOfModules = [];
    if (obj && obj.length > 0) {
        if (!Global.panelClientRectDetailsForElipseError) Global.panelClientRectDetailsForElipseError = obj[0].getClientRect();

        listPanels = obj.map((item: any) => {
            // console.log(AreaFinder.getAreaByModule(item.getAttrs()));
            const a = { ...item.getAttrs() };
            return {
                draggable: a.draggable,
                x: parseFloat(a.x.toFixed(1)),
                y: parseFloat(a.y.toFixed(1)),
                height: a.height,
                id: a.id,
                name: a.name,
                width: a.width,
            }
        });
        // Global.panelRows = listPanels;
        if (group.length > 0)
            listPanels.forEach((e: any) => {
                if (groupIds.indexOf(e.id) != -1) {
                    e.x = parseFloat(group[groupIds.indexOf(e.id)].x.toFixed(1));
                    e.y = parseFloat(group[groupIds.indexOf(e.id)].y.toFixed(1));
                }
            });

        let aTmp: any[] = _.sortBy(listPanels, 'y');
        ModList.listOfModules = aTmp;

        let r1: number[] = [];
        let r2: any[] = [];
        let r3: any[] = []
        let panelRows: any = [];
        aTmp.forEach((i: any) => {
            if (r1.indexOf(i.y) == -1) {
                if (r2.length > 0) {
                    r3.push(r2);
                }
                r1.push(i.y);
                r2 = [];
                r2.push(i);
            } else {
                r2.push(i);
            }
        });
        r3.push(r2);
        // console.log(r3)  //rows generate 
        r3.forEach((item: any) => {
            let r4 = _.sortBy(item, 'x');
            let temp: any = [];
            temp.push(r4[0]);
            for (let index = 1; index < r4.length; index++) {
                var gap: number = parseFloat((r4[index].x - r4[index - 1].x - r4[index - 1].width).toFixed(1));
                // console.log(gap)
                if (gap >= 0.6 && gap < 1) {
                    temp.push(r4[index])
                } else {
                    listOfGroups.push([...temp]);
                    temp = [];
                    temp.push(r4[index]);
                }
            }

            listOfGroups.push([...temp]);
        });
    } else {
        Global.panelRows = []
    }
    if (listOfGroups)
        ModList.listOfGroups = [...listOfGroups];

    return listOfGroups
}

export function sortRows(list: any[]) {
    let result: any = [];
    const panelsperblock = ModList.listOfModules.length > 2000 ? 25 : 8;
    let a: any = {
    }
    const sorty: any = {}
    list.forEach((item: any) => {
        let l = item.length > panelsperblock ? parseInt(item.length / panelsperblock + '') : 1;
        if (item.length % panelsperblock != 0) l++;
        const b: any = [];
        const y = item[0].y;
        let length = item.length;
        let start = 0;
        for (let i = 1; i <= l; i++) {
            const temp = length - start > panelsperblock ? item.slice(start, start + panelsperblock) : item.slice(start);
            if (temp && temp[0]?.x) {
                let min = temp[0].x;
                let max = temp[temp.length - 1].x + temp[temp.length - 1].width;
                b.push({
                    min,
                    max,
                    list: temp
                });
                start += panelsperblock;
            }
        }

        if (result.indexOf(y) == -1) {
            a[y] = [...b];
            result.push(y);
        } else {
            a[y] = [...a[y], ...b];
        }
    });
    ModGroup.panelsListBlocks = a;
    // console.log(ModGroup.panelsListBlocks);
    if (DrawFence.doClearPanels) {
        DrawFence.doClearPanels = false;
        setTimeout(DrawFence.clearPanels, 100);
    }
}
var haveIntersection = (r1: any, r2: any) => {
    return !(
        r2.x > r1.x + r1.w ||
        r2.x + r2.w < r1.x ||
        r2.y > r1.y + r1.h ||
        r2.y + r2.h < r1.y
    );
}

export function getListbyBlocks(miny: number, maxy: number, minx: number, maxx: number): any[] {
    if (ModGroup.panelsListBlocks) {

        let result: any[] = [];
        const keys = Object.keys(ModGroup.panelsListBlocks);
        keys.forEach((str: any) => {
            let s = parseFloat(str);
            const h = ModGroup.panelsListBlocks[str][0].list[0].height;
            // console.log((s >= miny && s <= maxy), ((s + h) >= miny && (s + h) <= maxy));
            if ((s >= miny && s <= maxy) || ((s + h) >= miny && (s + h) <= maxy) || (miny > s && miny < (s + h))) {
                const r: any = [];
                ModGroup.panelsListBlocks[str].forEach((item: any) => {
                    const g = {
                        x: item.min,
                        y: s,
                        w: item.max - item.min,
                        h: h
                    }
                    const srang = {
                        x: minx - 200,
                        y: miny - 100,
                        w: maxx - minx + 200,
                        h: maxy - miny + 100
                    }
                    // if ((item.min > minx && item.min < maxx) || (item.max > minx && item.max < maxx))
                    if (haveIntersection(g, srang))
                        r.push(...item.list);
                })
                result = [...result, ...r];
            }
        });

        return result;
    }
    return ModList.listOfModules;
}